module.exports = __webpack_public_path__ + "static/media/014.dc38e886.jpg";